import {AbstractVisualFeature} from '../../visual-feature.js';
import {CardsAndPromotions} from '../cards-and-promotions.js';

import {bannerCardsFactory} from './banner-cards.factory.js';

import PALETTE_SCHEMA from './banner-cards.palette-schema.yaml';

class BannerCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'BannerCards';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return bannerCardsFactory(PALETTE);
    }
}

new BannerCardsFeature(CardsAndPromotions);
